<div class="chat-widget-container">
  <!-- Chat Window -->
  <div *ngIf="isOpen" class="chat-window">
    <!-- Header -->
    <div class="chat-header">
      <span>Assistant Mesh Box AI</span>
      <button (click)="toggleOpen()" class="close-button">×</button>
    </div>

    <!-- Messages -->
    <div class="chat-messages" #messagesContainer>
      <div *ngFor="let msg of messages"
           class="message"
           [ngClass]="msg.role">
        <div class="message-content" [innerHTML]="msg.text"></div>
      </div>
      <div *ngIf="loading" class="loading">L'IA réfléchit...</div>
    </div>

    <!-- Input -->
    <form (submit)="handleSubmit(); $event.preventDefault()" class="chat-input-form">
      <input 
        type="text" 
        [(ngModel)]="input" 
        name="chatInput"
        placeholder="Posez une question..." 
        class="chat-input"
        autocomplete="off"
      />
      <button type="submit" [disabled]="loading" class="send-button">→</button>
    </form>
  </div>

  <!-- Floating Button -->
  <button 
    *ngIf="!isOpen" 
    (click)="toggleOpen()" 
    class="floating-button"
    aria-label="Ouvrir le chat"
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  </button>
</div>